module.exports = __webpack_public_path__ + "img/portfolio-big-03.e2247d75.jpg";